
import { defineComponent, PropType } from 'vue'

export interface Opz2Metric {
    label: string
    value: string | number
    hint?: string
    tone?: 'indigo' | 'teal' | 'wasabi' | 'muted' | 'red' | 'amber'
}

export default defineComponent({
    name: 'Opz2Metrics',
    props: {
        metrics: { type: Array as PropType<Opz2Metric[]>, required: true },
    },
})
